module.exports = __webpack_public_path__ + "img/6.31b23ba3.png";